import { UserSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useCoreUsersQuery = createQueryHook(
  'core.users',
  (params: {
    searchTerm?: string;
    sorting?: UserSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    coreUsersByOrganization: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        firstName: true,
        lastName: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.coreUsersByOrganization?.entries?.map((user) => ({
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
      })) ?? [],
  },
);
